import { inLayout } from './Layout'
export { inLayout }



// WEBPACK FOOTER //
// ./src/layouts/Layout/index.js